var map = {
	"./about/en/bio.md": 2669,
	"./about/en/intro.md": 5533,
	"./about/en/team.md": 7354,
	"./about/it/bio.md": 5883,
	"./about/it/intro.md": 1775,
	"./about/it/team.md": 2020,
	"./artist/en/ben-goldscheider-bio.md": 9691,
	"./artist/en/capella-savaria-bio.md": 3850,
	"./artist/en/die-kolner-akademie-bio.md": 3210,
	"./artist/en/evelyn-glennie-bio.md": 3546,
	"./artist/en/giuseppe-guarrera-bio.md": 8024,
	"./artist/en/hugo-ticciati-bio.md": 8002,
	"./artist/en/jean-rondeau-bio.md": 2283,
	"./artist/en/la-venexiana-bio.md": 6223,
	"./artist/en/mayumi-kanagawa-bio.md": 3426,
	"./artist/en/nevermind-bio.md": 1468,
	"./artist/en/o-modernt-bio.md": 1051,
	"./artist/en/odhecaton-bio.md": 5443,
	"./artist/en/scherzi-musicali-bio.md": 1924,
	"./artist/en/soqquadro-italiano-bio.md": 799,
	"./artist/en/vincenzo-capezzuto-bio.md": 8938,
	"./artist/it/ben-goldscheider-bio.md": 8229,
	"./artist/it/capella-savaria-bio.md": 9492,
	"./artist/it/die-kolner-akademie-bio.md": 1928,
	"./artist/it/evelyn-glennie-bio.md": 9100,
	"./artist/it/giuseppe-guarrera-bio.md": 3098,
	"./artist/it/hugo-ticciati-bio.md": 7436,
	"./artist/it/jean-rondeau-bio.md": 6333,
	"./artist/it/la-venexiana-bio.md": 401,
	"./artist/it/mayumi-kanagawa-bio.md": 2924,
	"./artist/it/nevermind-bio.md": 8814,
	"./artist/it/o-modernt-bio.md": 4125,
	"./artist/it/odhecaton-bio.md": 9869,
	"./artist/it/scherzi-musicali-bio.md": 978,
	"./artist/it/soqquadro-italiano-bio.md": 9437,
	"./artist/it/vincenzo-capezzuto-bio.md": 5104,
	"./contacts/en/contact-1.md": 293,
	"./contacts/en/contact-2.md": 3560,
	"./contacts/it/contact-1.md": 6659,
	"./contacts/it/contact-2.md": 1738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7229;